import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from './Icons';
export const SolutionSection = () => {
  return <section id="solution" className="py-24 bg-forest text-white relative overflow-hidden" data-id="element-287">
      {/* Abstract background elements */}
      <div className="absolute inset-0 opacity-10" data-id="element-288">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full border-[40px] border-white" data-id="element-289"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full border-[40px] border-white" data-id="element-290"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-291">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-292">
          <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-293">
            The good news?
          </h2>
          <p className="text-2xl text-accent font-bold mb-12" data-id="element-294">
            You don't have to find out the hard way.
          </p>

          <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-white/20 shadow-2xl" data-id="element-295">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent text-white mb-8" data-id="element-296">
              <CheckIcon className="w-8 h-8" data-id="element-297" />
            </div>
            <h3 className="text-3xl font-bold mb-6" data-id="element-298">
              One Call Changes Everything
            </h3>
            <p className="text-lg text-gray-200 mb-6 leading-relaxed" data-id="element-299">
              At South Coast Tree Care, we've seen it all — the overgrown palms
              dropping dead fronds on parked cars, the massive oak with a hollow
              trunk three feet from a bedroom window, the emergency calls that
              come in at 10pm because a tree just fell across a driveway.
            </p>
            <p className="text-xl font-bold text-white mb-8" data-id="element-300">
              We handle all of it.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-lg font-bold text-accent" data-id="element-301">
              <span data-id="element-302">Fast.</span>
              <span data-id="element-303">•</span>
              <span data-id="element-304">Clean.</span>
              <span data-id="element-305">•</span>
              <span data-id="element-306">Professional.</span>
              <span data-id="element-307">•</span>
              <span data-id="element-308">Done right.</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};